import React from "react";
import ExcelJS from "exceljs";

const ExcelVettingReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data)) {
            console.error("Data is not an array:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Define columns with headers
        worksheet.columns = [
            { header: 'Sl.No', key: 'serial', width: 10 },
            { header: 'File Type', key: 'file_type', width: 20 },
            { header: 'Vetting Type', key: 'vetting_type', width: 20 },
            { header: 'Vetting File No', key: 'file_name', width: 20 },
            { header: 'Existing File No', key: 'existingFileNo', width: 20 },
            { header: 'Law Hands Branch', key: 'lh_branch_name', width: 30 },
            { header: 'Bank Name', key: 'bank_name', width: 40 },
            { header: 'Product Name', key: 'product_name', width: 30 },
            { header: 'Bank Branch', key: 'bank_branch_name', width: 30 },
            { header: 'Borrower Name', key: 'borrower_name', width: 50 },
            { header: 'Property Owner', key: 'owner_name', width: 50 },
            { header: 'Application No', key: 'app_id', width: 40 },
            { header: 'File Status', key: 'status', width: 20 },
            { header: 'Login Date', key: 'login_date', width: 20 },
            { header: 'Update Date', key: 'updated_dt', width: 20 },
            { header: 'Vetting Officer', key: 'vetting_by', width: 30 },
            { header: 'Start Date', key: 'vetting_picked_dt', width: 20 },
            { header: 'Complete Date', key: 'vetting_completed_dt', width: 20 },
            { header: 'Sign Complete Date', key: 'sign_completed_dt', width: 20 },
            { header: 'Sign Complete By', key: 'sign_by', width: 30 },
            // { header: 'Number of Working', key: 'no_of_working', width: 20 },
            { header: 'Lod Count', key: 'lod_total', width: 20 },
            { header: 'Property Address', key: 'address', width: 120 },
            { header: 'Mistake Made by', key: 'mistake_made_by', width: 20 },
            { header: 'Error Type', key: 'error_category', width: 20 },
            { header: 'Place of Error Category', key: 'vetting_category', width: 20 },
            { header: 'Sub Category', key: 'vetting_sub_category', width: 20 },
            { header: 'Re-Vetting Reason', key: 'vetting_reason', width: 20 },
            { header: 'Hold by', key: 'hold_by', width: 20 },
            { header: 'Hold Date', key: 'hold_dt', width: 20 },
            { header: 'Hold Reason', key: 'hold_reason', width: 30 },
            { header: 'UnHold by', key: 'unhold_by', width: 20 },
            { header: 'UnHold Date', key: 'unhold_dt', width: 20 },
            { header: 'UnHold Reason', key: 'unhold_reason', width: 30 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 14 };
        });

        const flattenedData = data.map((report, index) => {
            return {
                serial: index + 1,
                file_type: report.existingFileNo ? "Existing File" : "New File",
                vetting_type: report.vetting_type,
                file_name: report.file_name ? report.file_name : "",
                existingFileNo: report.existingFileNo ? report.existingFileNo : "",
                lh_branch_name: report.lh_branch_name ? report.lh_branch_name : "",
                bank_name: report.bank_name ? report.bank_name : "",
                product_name: report.product_name ? report.product_name : "",
                bank_branch_name: report.bank_branch_name ? report.bank_branch_name : "",
                borrower_name: report.borrower_name ? report.borrower_name : "",
                owner_name: report.owner_name ? report.owner_name : "",
                app_id: report.app_id ? report.app_id : "",
                status: report.status ? report.status : "",
                login_date: report.login_date ? parseCustomDate(report.login_date) : null,
                updated_dt: report.updated_dt ? parseCustomDate(report.updated_dt) : null,
                vetting_by: report.vetting_by ? report.vetting_by : "",
                vetting_picked_dt: report.vetting_picked_dt ? parseCustomDate(report.vetting_picked_dt) : null,
                vetting_completed_dt: report.vetting_completed_dt ? parseCustomDate(report.vetting_completed_dt) : null,
                sign_completed_dt: report.sign_completed_dt ? parseCustomDate(report.sign_completed_dt) : null,
                sign_by: report.sign_by ? report.sign_by : "",
                no_of_working: report.no_of_working || 0,
                lod_total: report.lod_total,
                address: report.address,
                mistake_made_by: report.mistake_made_by,
                error_category: report.error_category,
                vetting_category: report.vetting_category,
                vetting_sub_category: report.vetting_sub_category,
                vetting_reason: report.vetting_reason,
                hold_by: report.hold_by,
                hold_dt: parseCustomDate(report.hold_dt),
                hold_reason: report.hold_reason,
                unhold_by: report.unhold_by,
                unhold_dt: parseCustomDate(report.unhold_dt),
                unhold_reason: report.unhold_reason
            };
        });

        // Add data rows with custom cell alignment and wrap text
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);
            row.eachCell((cell, colNumber) => {
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                if ([21].includes(colNumber)) {
                    cell.numFmt = '0'; // Integer format
                } else if ([7, 22, 25].includes(colNumber)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                } else if ([14, 15, 17, 18, 19, 27, 30].includes(colNumber) && cell.value instanceof Date) {
                    cell.numFmt = 'dd-mm-yyyy hh:mm:ss'; // For date & time format
                }
            });
        });
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Vetting Subreport ${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <button className="excel-download-btn" onClick={exportExcelFile}>
                Download as Excel
            </button>
        </>
    );
};

export default ExcelVettingReport;

// Force UTC interpretation
export function parseCustomDate(dateString) {
    if (!dateString) return null;
    const [datePart, timePart] = String(dateString).trim().split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const timeBits = timePart ? timePart.split(":").map(Number) : [0, 0, 0];
    const hour = timeBits[0] ?? 0;
    const minute = timeBits[1] ?? 0;
    const second = timeBits[2] ?? 0;
    if (!Number.isFinite(day) || !Number.isFinite(month) || !Number.isFinite(year)) {
        return null;
    }
    // Create as UTC
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
}
